import {useRef, useEffect, useCallback} from 'react';
import {useTranslation} from 'react-i18next';

const MAX_LENGTH = 300;

type Props = {
  value: string;
  onChange: (value: string) => void;
};

function PublicShortAnswer({value, onChange}: Props) {
  const {t} = useTranslation();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-resize textarea height to fit content
  const adjustHeight = useCallback(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, []);

  useEffect(() => {
    adjustHeight();
  }, [value, adjustHeight]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newVal = e.target.value;
    if (newVal.length <= MAX_LENGTH) {
      onChange(newVal);
    }
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <div className="flex flex-col gap-3 mt-3">
      {/* Auto-growing textarea — matches AppTextInput styling */}
      <textarea
        ref={textareaRef}
        rows={1}
        maxLength={MAX_LENGTH}
        placeholder={t('forms.public.shortAnswerPlaceholder')}
        value={value}
        onChange={handleChange}
        className="w-full py-[10px] pl-3 pr-3 rounded-[4px] border-none bg-[#1D1B2014] focus:outline-none text-[16px] text-textColor placeholder:text-black resize-none overflow-hidden"
      />

      {/* Clear text field link */}
      <div className="flex">
        <button
          type="button"
          onClick={handleClear}
          className="text-linkBlue underline hover:opacity-80 transition-opacity">
          {t('forms.public.clearField')}
        </button>
      </div>
    </div>
  );
}

export default PublicShortAnswer;
